import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cache = null;

/** Fetch published pages flagged for the navigation menu (ordered). */
export default function useMenuPages() {
    const [pages, setPages] = useState(cache || []);

    useEffect(() => {
        let alive = true;
        if (cache) {
            setPages(cache);
            return;
        }
        axios
            .get(`${API}/custom-pages`)
            .then((r) => {
                cache = Array.isArray(r.data) ? r.data : [];
                if (alive) setPages(cache);
            })
            .catch(() => {
                if (alive) setPages([]);
            });
        return () => {
            alive = false;
        };
    }, []);

    return pages;
}

/** Clear the menu cache (call after admin publish/menu changes). */
export function invalidateMenuPages() {
    cache = null;
}
